import template from './page-new-home-video.html';
import controller from './page-new-home-video.controller';
import './page.scss';

let newHomeVideoComponent = {
  bindings: {},
  template,
  controller
};

export default newHomeVideoComponent;


// WEBPACK FOOTER //
// ./client/app/components/page/page-new-home-video.component.js